import { contactData } from '@/mocks/homeMangaData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {contactData.subtitle}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 text-center max-w-2xl mx-auto">
              {contactData.desc}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {contactData.items.map((item) => (
                <div
                  key={item.label}
                  className="bg-background-50 rounded-xl p-5 text-center border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-primary-100 text-primary-600 mb-3">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <span className="block text-xs font-medium text-foreground-500 mb-1">{item.label}</span>
                  <span className="block text-sm font-semibold text-foreground-800">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}